import { useCallback } from 'react'
import _ from 'lodash'

// eslint-disable-next-line
const useDebounceInput = (fn, delay, deps = []) => useCallback(
  _.debounce(fn, delay),
  deps
)

export default useDebounceInput
